// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__363Ri","selected":"Chip_selected__2iaR-"};